import React from "react";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath} from "react-hook-form";
import ComboBox, {ComboBoxProps} from "./ComboBox";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {CentroDiCostoRecord} from "@commons/mapping/CentroDiCostoRecord";

interface Props<T extends FieldValues> extends Pick<ComboBoxProps<T>, 'addOnBefore' | 'addOnAfter' | 'label' | 'inlineLabel' | 'disabled'> {
    control: Control<T>,
    name: FieldPath<T>,
    defaultValue: any,
    label: string,
    data?: CentroDiCostoRecord[]
    isLoading?: boolean

    disabled?: boolean
    inlineLabel?: boolean
    onChangeEx?: React.Dispatch<React.SetStateAction<CentroDiCostoRecord | null>>
}

export function ComboBoxCdiC<T extends FieldValues>(props: Props<T>) {
    const {control, name, defaultValue, label, data, isLoading, disabled, inlineLabel = false, onChangeEx, ...rest} = props
    return <Controller name={name}
                       control={control}
                       defaultValue={defaultValue}
                       rules={{required: false}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<CentroDiCostoRecord> label={label} inlineLabel={inlineLabel} disabled={disabled}
                                                              value={{id: value}}
                                                              onChange={(value) => {
                                                                  onChange(value?.id)
                                                                  if (onChangeEx)
                                                                      onChangeEx(value);
                                                              }}
                                                              fieldState={fieldState}
                                                              data={data}
                                                              isLoading={isLoading}
                                                              searchablePropsName={["id", "descrizione"]}
                                                              isSameFn={(a, z) => (a && z) ? a.id === z.id : false}
                                                              keyValueFn={(v) => v.id!}
                                                              displayValueFn={(v) => data && v ? v.descrizione! : ''}
                                                              {...rest}
                               />
                           )
                       }}
    />
}

export default ComboBoxCdiC;